<main class="demo-turnstile-gate">
  <div class="demo-turnstile-gate__card">
    <p class="demo-turnstile-gate__logo">Viajes Demo</p>
    <h1>{{ 'turnstile.title' | demoTranslate }}</h1>
    <p class="demo-turnstile-gate__description">{{ 'turnstile.description' | demoTranslate }}</p>
    <div class="demo-turnstile-gate__widget" demoTurnstileWidget></div>
    @if (turnstile.error()) {
      <p class="demo-turnstile-gate__error" role="status">{{ 'turnstile.error' | demoTranslate }}</p>
    }
  </div>
</main>
